module.exports = __webpack_public_path__ + "img/grafic-pie.bb30bcf8.svg";